import { CreatePageLayout } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import AgreementVendorForm from './AgreementVendorForm';
import { useVendorId, useVendorsUrl } from '../routes';
import useVendorService from '../useVendorService';
import AgreementVendorBreadcrumbs from './AgreementVendorBreadcrumbs';
import { useNavigate } from 'react-router-dom';
import { AGREEMENT_STATUS } from '../constants';

const AgreementVendorPage = () => {
  const id = useVendorId()!;
  const navigate = useNavigate();
  const { getSingleEntityUrl } = useVendorsUrl();
  const { getById, agreementVendor, getVendorAgreements, finalizeVendorValidationSchemaFunc } = useVendorService();

  return (
    <FormShowTemplate
      getDataFunc={async () => {
        const data = await getById(id, true);
        const { result } = await getVendorAgreements(id, {
          pageSize: 30,
          pageNumber: 0,
          filter: {
            status: {
              eq: AGREEMENT_STATUS.DRAFT,
            },
          },
        });
        const agreementDetails = result[0];
        return {
          ...data,
          agreementDetails,
        };
      }}
      afterSubmit={{
        message: 'You are awesome! The Vendor has been successfully activated.',
        execute: () => {
          navigate(getSingleEntityUrl(id));
        },
      }}
      getValidationSchemaFunc={finalizeVendorValidationSchemaFunc}
      submitFormFunc={async agreementFormData => agreementVendor(id, agreementFormData)}
    >
      <CreatePageLayout title="Vendor agreement" breadcrumbs={<AgreementVendorBreadcrumbs />}>
        <AgreementVendorForm />
      </CreatePageLayout>
    </FormShowTemplate>
  );
};

export default AgreementVendorPage;
